/**
 * Created by sswaminathan on 1/24/22
 * File: UnClaimSubscriptionModal
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Form, FormLayout, SubmitButton } from '@panwds/react-form-legacy'
import {
  Button,
  LoadingPage,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */
import { useCallback, useMemo, useState } from 'react'
import { ReClaimLicenses } from '../../../common/actions/GlobalActions'
import ZIndex from '../../../common/components/zIndex/ZIndex'
import { VIEW_MANAGE_TENANT } from '../../../common/constants/GlobalConstants'
import { selectTreeNode } from '../../../common/reducers/actions/TreeReducer.actions'
import { setCurrentViewing } from '../../../common/utils/Sparky'
import {
  CANCEL_BUTTON,
  RECLAIM_ERROR_MSG, SUCCESS_MESSAGE,
  UNCLAIM_SUBSCRIPTION_BUTTON_TEXT
} from '../constants/SubscriptionConstant'
import TenantSelection from '../tenantSelection/TenantSelection'
import WorkFlow from '../workFlow/WorkFlow'

const UnClaimSubscriptionModal = ({ closeModal, isOpen, title, content, setShowErrorMsg, handleSubmit, row, ...rest }) => {
  const [isFormLoading, setFormLoading] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const onSubmit = useCallback(async (values) => {
    setFormLoading(true)
    const response = {
      reclaim_tsg_id: values['tsgId'].key,
      hash: row.original.hash,
      license_id: row.original.license_id
    }
    ReClaimLicenses(response, row.original.tsg_id).then((data) => {
      setFormLoading(false)
      rest.dispatch(selectTreeNode(rest.sgKeyBy[values['tsgId'].key]))
      setCurrentViewing(VIEW_MANAGE_TENANT)
      handleSubmit(SUCCESS_MESSAGE.replace('$', values['tsgId'].description), false)
      closeModal()
    }, (err) => {
      setShowErrorMsg((prev) => {
        return RECLAIM_ERROR_MSG
      })
      handleSubmit('', true)
      closeModal()
      setFormLoading(false)
    })
  }, [row.original?.hash, row.original?.license_id, row.original?.tsg_id, rest, closeModal, setShowErrorMsg, handleSubmit])

  const getUnClaimsContent = useMemo(() => {
    return isFormLoading ? <LoadingPage/> : <div className={'tw-flex tw-flex-col tw-p-0 tw-m-0'}>
      <WorkFlow showWorkFlow={false}/>
      <div className='tw-flex-grow'>
        <TenantSelection showCspDropDown={false} currentTsg={row.original.tsg_id} {...{ ...rest, setDisabled }}/>
      </div>
    </div>
  }, [row.original.tsg_id, rest, isFormLoading])

  return <ZIndex>
    <Modal style={{ top: '12%', width: '390px' }}
      onClose={closeModal}
      isOpen={isOpen}
      confirmClose={false}
    >
      <Form style={{ width: '50%' }} mode='onBlur' onSubmit={onSubmit} formProps={{ autoComplete: 'off' }} >
        <FormLayout>
          <div className='tw-flex tw-flex-col'>
            <ModalHeader title={title} />
            <ModalBody style={{ padding: '0px' }} >
              {getUnClaimsContent}
            </ModalBody>
            <ModalFooter style={{ marginTop: '80px', paddingTop: '15px' }}>
              <Button onClick={closeModal} >
                {CANCEL_BUTTON}
              </Button>
              <SubmitButton
                appearance={'primary'}
                type={'submit'}
                disabled={disabled}
              >
                {UNCLAIM_SUBSCRIPTION_BUTTON_TEXT}
              </SubmitButton>
            </ModalFooter>
          </div>
        </FormLayout>
      </Form>
    </Modal>
  </ZIndex>
}

UnClaimSubscriptionModal.propTypes = {}
export default UnClaimSubscriptionModal
